const apiUrl = process.env.REACT_APP_API_URL;

const API = {

  //User
  GET_USER: `${apiUrl}/api/tas/User/GetUserByEmail`,

  //Home Count API
  GET_PENDING_TASK_COUNT: `${apiUrl}/api/tas/Home/pendingtaskcount`,
  GET_TRAINING_REQUEST_COUNT: `${apiUrl}/api/tas/Home/trainingrequestcount`,
  GET_TRAINING_RECORDS_COUNT: `${apiUrl}/api/tas/Home/trainingrecordscount`,
  GET_ALL_PENDING_TASK_COUNT: `${apiUrl}/api/tas/Home/counts`,


  //Master Data
  GET_COURSE_CODE: `${apiUrl}/api/tas/MasterData/courses`,
  GET_VENDOR: `${apiUrl}/api/tas/MasterData/vendors`,
  GET_SKILLS_TYPE: `${apiUrl}/api/tas/MasterData/skills`,
  GET_PTES_TYPE: `${apiUrl}/api/tas/MasterData/ptes`,
  GET_COURSE_QUESTIONNAIRE_VALUES: `${apiUrl}/api/tas/MasterData/coursequestionaires`,
  GET_LOU_VALUES: `${apiUrl}/api/tas/MasterData/letter-of-undertakings`,
  GET_CATEGORIES: `${apiUrl}/api/tas/MasterData/categories`,
  GET_PROFICIENCY: `${apiUrl}/api/tas/MasterData/proficiencies`,
  GET_EMPLOYEES: `${apiUrl}/api/tas/MasterData/employees`,
  GET_DIVISION_CODE: `${apiUrl}/api/tas/MasterData/divisioncode`,
  GET_DEPARTMENT_NAME: `${apiUrl}/api/tas/MasterData/departmentname`,
  GET_JOB_DESIGNATION: `${apiUrl}/api/tas/MasterData/jobdesignation`,
  GET_LEVEL_MASTERDATA: `${apiUrl}/api/tas/MasterData/levels`,
  

  GET_SKILL_MATRIX: `${apiUrl}/api/tas/SkillMatrix/skillMatrixById`,
  GET_SKILL_OVERVIEW_MATRIX: `${apiUrl}/api/tas/SkillMatrix/GetSkillOverView`,

  //Notification
  GET_NOTIFICATIONS: `${apiUrl}/api/tas/Notification/GetUnReadNotification`,
  GET_NOTIFICATION_COUNT: `${apiUrl}/api/tas/Notification/GetUnReadNotificationCount`,
  PUT_UPDATE_NOTIFICATION : `${apiUrl}/api/tas/Notification/UpdateWebNotificationStatus`,

  //Categories
  GET_CATEGORY1: `${apiUrl}/api/tas/Category/Category1`,
  GET_CATEGORY2: `${apiUrl}/api/tas/Category/Category2`,
  GET_PARDICULAR_CATEGORY: `${apiUrl}/api/tas/Category/categoryById`,
  EXIST_CATEGORY: `${apiUrl}/api/tas/Category/category/exist`,
  POST_CATEGORY: `${apiUrl}/api/tas/Category/categories`,
  PUT_CATEGORY: `${apiUrl}/api/tas/Category/Categories`,
  DELETE_CATEORY: `${apiUrl}/api/tas/Category/RemoveCategories`,
  DOCUMENT_EXIST: `${apiUrl}/api/tas/Category/document/exist`,

  //Home Screen
  POST_APPLY_FOR_TRAINING: `${apiUrl}/api/tas/TrainingRequest/ApplyTraining`,
  IS_COURSE_ADD : `${apiUrl}/api/tas/TrainingManagement/IsCourseAdded`,
  GET_FILE_BY_ID: `${apiUrl}/api/tas/File/GetFileById`,
  GET_UPCOMING_TRAINING_HOME: `${apiUrl}/api/tas/TrainingManagement/myupcoming/trainings`,

  POSTPUT_MANUAL_TRAININGS: `${apiUrl}/api/tas/ProficiencyDateRange/ManualTraining`,
  UPDATE_TRAINING_RECORD: `${apiUrl}/api/tas/TrainingManagement/updateTrainingRecord`,

  //MypendingTasks
  GET_PENDING_SUBMISSIONS: `${apiUrl}/api/tas/TrainingRequest/PendingSubmissions`,
  GET_PENDING_APPROVALS: `${apiUrl}/api/tas/TrainingRequest/PendingApprovals`,
  POST_UPLOAD_FILES: `${apiUrl}/api/tas/File/Uploadfiles`,
  GET_TRAINING_REQUEST_ID: `${apiUrl}/api/tas/TrainingRequest/TrainingRequestById`,
  POST_UPLOAD_CERTIFICATE: `${apiUrl}/api/tas/File/UploadCertificate`,
  GET_COURSE_QUESTIONNAIRE_COURSEID: `${apiUrl}/api/tas/CourseQuestionare/GetCourseQuestionsByCourseId`,
  POST_COURSE_QUESTIONNAIRE_ANS: `${apiUrl}/api/tas/TrainingRequest/CourseQuestionaire`,
  POST_PTE1_EVALUATION: `${apiUrl}/api/tas/PteEvaluation/EvaluateTrainingRequest`,

  GET_APPROVE_TRAINING: `${apiUrl}/api/tas/TrainingRequest/approve-trainingrequest`,
  GET_PTE_BY_ID: `${apiUrl}/api/tas/TrainingRequest/ptedatasbyid`,

  GET_CANCEL_TRAINING: `${apiUrl}/api/tas/TrainingRequest/cancel-trainingrequest`,
  GET_COURSE_QUESTIONAIRE: `${apiUrl}/api/tas/TrainingRequest/coursequestionairedatasbyid`,
  POST_COURSE_QUESTIONAIRE: `${apiUrl}/api/tas/TrainingRequest/coursequestionairesubmission`,
  GET_PENDING_PTE_ACKNOWLEDGE: `${apiUrl}/api/tas/TrainingRequest/ptedatasbyid`,
  POST_PENDING_PTE_ACKNOWLEDGE: `${apiUrl}/api/tas/PteEvaluation/approve-pte`,
  GET_PENDING_LOU: `${apiUrl}/api/tas/TrainingRequest/loudatasbyid`,
  POST_PENDING_LOU: `${apiUrl}/api/tas/TrainingRequest/lousubmission`,
  GET_PENDING_ANSWER_OPTIONS: `${apiUrl}/api/tas/MasterData/evaluationanswer`,
  POST_CERTIFICATE_UPLOAD: `${apiUrl}/api/tas/File/upload/certificate`,
  GET_PTE_SKILL_OPTIONS: `${apiUrl}/api/tas/MasterData/pte-skillstatus`,
  SUBMIT_PTE: `${apiUrl}/api/tas/PteEvaluation/submit-pte`,
  ACKNOWLEDGE_PTE: `${apiUrl}/api/tas/PteEvaluation/acknowledge-pte`,

  GET_PENDING_TASKS: `${apiUrl}/api/tas/TrainingRequest/pendingtasks`,
  GET_PENDING_TASK_DETAILS: `${apiUrl}/api/tas/TrainingRequest/trainingrequestbyid`,
  GET_REJECT_TRAINING: `${apiUrl}/api/tas/TrainingRequest/reject-trainingrequest`,
  GET_HISTORY_LOG: `${apiUrl}/api/tas/TrainingManagement/historyLog`,
  GET_SKILL_STATUS: `${apiUrl}/api/tas/MasterData/pte-skillstatus`,
  GET_EVAL_ANS: `${apiUrl}/api/tas/MasterData/pteanswer`,
  GET_PROFICIENCIES_DATA: `${apiUrl}/api/tas/MasterData/proficiencies`,
  POST_CQ_APPROVAL : `${apiUrl}/api/tas/TrainingRequest/coursequestionaireApproval`,
  GET_COURSE_QUEST_ANSWERS : `${apiUrl}/api/tas/MasterData/coursequestionaireanswer`,
  POST_USER_ELIGIBLE_IN_OTHER_TRAINING:`${apiUrl}/api/tas/TrainingRequest/UserEngagedinOtherTraining`,

  //Vendor
  GET_VENDORS: `${apiUrl}/api/tas/Vendor/Vendors`,
  Common_VENDOR: `${apiUrl}/api/tas/Vendor/vendor`,
  VENDOR_EXISTS: `${apiUrl}/api/tas/Vendor/vendor/exists`,
  VENDOR_EMAIL_VALIDATE: `${apiUrl}/api/tas/Vendor/email-exists`,
  POST_VALIDATE_VENDOR : `${apiUrl}/api/tas/Vendor/vendor/validate`,

  //Pte Evaluation 
  APPROVE_PTE: `${apiUrl}/api/tas/PteEvaluation/approve-pte`,
  REJECT_PTE: `${apiUrl}/api/tas/PteEvaluation/reject-pte`,
  GET_PTE_EVALUATION: `${apiUrl}/api/tas/PteEvaluation/GetPTEEvaluation`,


  //skills 
  GET_SKILLS: `${apiUrl}/api/tas/Skill/skills`,
  PUT_UPDATE_SKILLS: `${apiUrl}/api/tas/Skill/skill`,
  GET_SKILLS_BYID: `${apiUrl}/api/tas/Skill/skill`,
  DELETE_SKILLS: `${apiUrl}/api/tas/Skill/skills`,
  GET_EXIST_SKILL: `${apiUrl}/api/tas/Skill/skill/exist`,
  POST_VALIDATE_SKILLS : `${apiUrl}/api/tas/Skill/skill/validate`,

  //Level
  GET_LEVEL: `${apiUrl}/api/tas/Level/levels`,
  PUT_LEVEL: `${apiUrl}/api/tas/Level/level`,
  DELETE_LEVEL: `${apiUrl}/api/tas/Level/levels`,
  GET_LEVEL_BYID: `${apiUrl}/api/tas/Level/level`,
  GET_EXIST_LEVEL: `${apiUrl}/api/tas/Level/level/exist`,
  POST_VALIDATE_LEVELS : `${apiUrl}/api/tas/Level/level/validate`,

  //CourseQuestionnaire
  GET_COURSE_QUESTION: `${apiUrl}/api/tas/CourseQuestionare/coursequestionaires`,
  GET_CQ_BY_ID: `${apiUrl}/api/tas/CourseQuestionare/coursequestionaire`,

  // UpcomingTraining
  GET_UPCOMING_TRAINING_LIST: `${apiUrl}/api/tas/TrainingManagement/upcoming/trainings`,
  GET_TRAININING_DETAILS_ID: `${apiUrl}/api/tas/TrainingManagement/TrainingById`,
  SAVE_TRAININING_DETAILS: `${apiUrl}/api/tas/TrainingManagement/addOrUpdateTraining`,
  REMOVE_TRAININING_DETAILS: `${apiUrl}/api/tas/TrainingManagement/removetrainings`,
  // APPLY_FOR_TRAINING: `${apiUrl}/api/tas/TrainingRequest/ApplyTraining`,
  APPLY_FOR_TRAINING: `${apiUrl}/api/tas/TrainingRequest/applytraining`,
  IS_TRAINING_APPLIED: `${apiUrl}/api/tas/TrainingManagement/istrainingapplied`,
  IS_SUPERVISOR_MANAGER_PRESENT: `${apiUrl}/api/tas/TrainingManagement/issupervisormanagerpresent`,
  IS_TRAINING_EXIST: `${apiUrl}/api/tas/TrainingManagement/istrainingexists`,
  IS_TRAINING_ACTIVE: `${apiUrl}/api/tas/TrainingManagement/validateTrainingMapping`,
  

  //Course Catalogue
  GET_COURSE_CATALOGUE: `${apiUrl}/api/tas/Course/GetCourseCatalogue`,
  GET_COURSE_BY_ID: `${apiUrl}/api/tas/Course/GetCourseCatalogueById`,
  POST_ADD_UPDATE_COURSE: `${apiUrl}/api/tas/Course/AddOrUpdateCourseCatalogue`,
  EXIST_COURSE: `${apiUrl}/api/tas/Course/course/exist`,
  STATUS_VALIDATION: `${apiUrl}/api/tas/Course/disablevalidation`,
  

  POST_COURSE_QUESTIONS: `${apiUrl}/api/tas/CourseQuestionaire/coursequestionaire`,
  POST_PTE: `${apiUrl}/api/tas/Pte/ptequestion`,
  POST_LOU: `${apiUrl}/api/tas/Lou/louquestion`,

  GET_LOU_BYID: `${apiUrl}/api/tas/Lou/louquestions`,
  GET_PTE_BYID: `${apiUrl}/api/tas/Pte/ptequestions`,
  GET_COURSE_BYID: `${apiUrl}/api/tas/CourseQuestionaire/coursequestionaire`,


  //Main Role
  GET_MAIN_ROLES: `${apiUrl}/api/tas/Role/mainroles`,
  PUT_MAIN_ROLE: `${apiUrl}/api/tas/Role/mainrole`,
  GET_MAIN_ROLE: `${apiUrl}/api/tas/Role/mainrole`,
  DELETE_MAIN_ROLE_BYID: `${apiUrl}/api/tas/Role/mainrole`,
  GET_MAIN_JOB_BYID: `${apiUrl}/api/tas/Role/mainjob`,
  POST_VALIDATE_ROLES : `${apiUrl}/api/tas/Role/roles/validate`,

  //Supporting Role
  GET_SUPPORTING_ROLES: `${apiUrl}/api/tas/Role/supportingroles`,
  PUT_SUPPORTING_ROLE: `${apiUrl}/api/tas/Role/supportingrole`,
  GET_SUPPORTING_ROLE: `${apiUrl}/api/tas/Role/supportingrole`,
  DELETE_SUPPORTING_ROLE_BYID: `${apiUrl}/api/tas/Role/supportingrole`,
  GET_SUPPORTING_JOB_BYID: `${apiUrl}/api/tas/Role/supportingjob`,

  //Course Catalogue
  GET_COURSE_CATALOGUE: `${apiUrl}/api/tas/Course/GetCourseCatalogue`,
  GET_COURSE_BY_ID: `${apiUrl}/api/tas/Course/GetCourseCatalogueById`,
  POST_ADD_UPDATE_COURSE: `${apiUrl}/api/tas/Course/AddOrUpdateCourseCatalogue`,
  EXIST_COURSE: `${apiUrl}/api/tas/Course/course/exist`,
  
  //Skill Proficiency
  GET_SKILL_PROFICIENCY: `${apiUrl}/api/tas/ProficiencyDateRange`,
  POST_SKILL_PROCIFIENCY: `${apiUrl}/api/tas/ProficiencyDateRange`,
  POST_ISUPDATE_SKILL_MATRIX:`${apiUrl}/api/tas/SkillMatrix/IsUpdateSkillMatrix`,

  //Main Role
  GET_MAIN_ROLES: `${apiUrl}/api/tas/Role/mainroles`,
  PUT_MAIN_ROLE: `${apiUrl}/api/tas/Role/mainrole`,
  GET_MAIN_ROLE: `${apiUrl}/api/tas/Role/mainrole`,
  DELETE_MAIN_ROLE_BYID: `${apiUrl}/api/tas/Role/mainrole`,
  GET_MAIN_JOB_BYID: `${apiUrl}/api/tas/Role/mainjob`,

  //Supporting Role
  GET_SUPPORTING_ROLES: `${apiUrl}/api/tas/Role/supportingroles`,
  PUT_SUPPORTING_ROLE: `${apiUrl}/api/tas/Role/supportingrole`,
  GET_SUPPORTING_ROLE: `${apiUrl}/api/tas/Role/supportingrole`,
  DELETE_SUPPORTING_ROLE_BYID: `${apiUrl}/api/tas/Role/supportingrole`,
  GET_SUPPORTING_JOB_BYID: `${apiUrl}/api/tas/Role/supportingjob`,

  //My Traning
  GET_MYTRAINING: `${apiUrl}/api/tas/TrainingManagement/trainings`,
  GET_MYTRAININGID: `${apiUrl}/api/tas/TrainingRequest/trainingrequestbyid`,

  //File
  GET_FILES_URL: `${apiUrl}/api/tas/File/fileById`,
  GET_UPLOAD_TRAINING_BOND: `${apiUrl}/api/tas/File/upload/trainingBond`,

  //Team training
  GET_TEAM_MEMBERS: `${apiUrl}/api/tas/TeamManagement/teammembers`,
  GET_TEAM_TRAINING: `${apiUrl}/api/tas/TeamManagement/teamtraining`,
  GET_TEAM_TRAINING_BY_ID: `${apiUrl}/api/tas/TrainingRequest/trainingrequestbyid`,
  GET_TEAM_TRAINING_HISTORY: `${apiUrl}/api/tas/TrainingManagement/historyLog`,
  GET_TEAM_TRAINING_COUNT : `${apiUrl}/api/tas/TeamManagement/teamtrainingcount`,

  //SkillMatrix
  GET_SKILL_OVERVIEW: `${apiUrl}/api/tas/SkillMatrix/GetSkillOverView`,

  //Team skill chart
  GET_TEAM_SKILL_CHART: `${apiUrl}/api/tas/TeamManagement/teamMembers`,
  GET_ALL_MEMBERS_CHART: `${apiUrl}/api/tas/TeamManagement/allmembers`,
  GET_CAPABILITY_SUMMARY: `${apiUrl}/api/tas/TeamManagement/skillProficiencySummary`,
  GET_TEAM_SKILL_CHART_BY_ID: `${apiUrl}/api/tas/SkillMatrix/skillMatrixById`,
  UPDATE_TEAM_SKILL_CHART: `${apiUrl}/api/tas/SkillMatrix/UpdateSkillMatrix`,
  GET_TEAM_USER_DETAILS: `${apiUrl}/api/tas/SkillMatrix/GetUserDetails`,
  GET_AUDIT_LOG: `${apiUrl}/api/tas/SkillMatrix/AuditLog`,

  //MasterData 
  GET_SKILL_STATUS: `${apiUrl}/api/tas/MasterData/pte-skillstatus`,
  GET_EVAL_ANS_NEW: `${apiUrl}/api/tas/MasterData/evaluationanswer`,

  //Traning records
  GET_TRAINING_RECORDS_LIST:`${apiUrl}/api/tas/TrainingRequest/trainingrecords`,
  GET_ADMIN_EMPLOYEE_LIST: `${apiUrl}/api/tas/User/GetUsers?includeAdmin=true`,
  GET_CURRENT_STATUS: `${apiUrl}/api/tas/MasterData/status`,

  //My request status 
  GET_REQUEST_STATUS: `${apiUrl}/api/tas/TrainingRequest/requeststatus`,

  //Course Completion
  POST_COURSE_COMPLETION : `${apiUrl}/api/tas/TrainingRequest/coursecompletion`,

  //Certificate Approve 
  POST_CERT_APPROVE : `${apiUrl}/api/tas/TrainingRequest/approve-certificate`,
  POST_CERT_REJECT : `${apiUrl}/api/tas/TrainingRequest/reject-certificate`,

  //Authentication 
  PUT_AUTHENTICATE : `${apiUrl}/api/tas/Authentication/token`,
  PUT_INVALID_TOKEN : `${apiUrl}/api/tas/Authentication/invalidate-token`,

  CHECKMAINROLE_DUPLICATE: `${apiUrl}/api/tas/Role/IsRoleDuplicate`,
  CHECKCOURSE_DUPLICATE: `${apiUrl}/api/tas/Course/IsCourseDuplicate`,
  CLONE_ALLROLES: `${apiUrl}/api/tas/Role/clone`,
  CLONE_COURSE: `${apiUrl}/api/tas/Course/CloneCourse`,
};
export default API;
